export const MAIN_APP_SCROLLABLE_ELEMENT_SELECTOR = '#app-main-container .route-animation-viewport';
